import React from "react";
import { connect } from "react-redux";
import "react-datepicker/dist/react-datepicker.css";
import axios from "axios";
import API from "../helpers/api";
import { UpdateNotesData, getNoteById } from "../Actions/ShipNotesAPI";
import { toast } from "react-toastify";
import DatePicker from "react-datepicker";
import Moment from "moment";
import { withTranslation } from "react-i18next";
let currentuser = JSON.parse(localStorage.getItem("currentUser"));


class EditNotes extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            inputData: {
                noteID: 0,
                shipId: 0,
                title: "",
                remarks: "",
                date: "",
                createdBy: ""
            },
            SelectedDate: "",
            DatePickerIsOpen: false,
        };
        this.handleInputChange = this.handleInputChange.bind(this);
        this.handleDateChange = this.handleDateChange.bind(this);
        this.handleBlur = this.handleBlur.bind(this);
        this.UpdateNotes = this.UpdateNotes.bind(this);
        this.openDatePicker = this.openDatePicker.bind(this);
    }

    componentDidMount() {
        const { dispatch, match } = this.props;
        dispatch(getNoteById(match.params.id));
        dispatch({ type: "SubBannerTitle", data: "SHIP REPORTS" })
    }

    static getDerivedStateFromProps(nextProps, prevState) {
        const { dispatch, NoteDetail } = nextProps;
        if (NoteDetail) {
            prevState.inputData.noteID = NoteDetail.noteID;
            prevState.inputData.shipId = NoteDetail.shipId;
            prevState.inputData.title = NoteDetail.title;
            prevState.inputData.remarks = NoteDetail.remarks;
            prevState.inputData.date = Moment(NoteDetail.date).format("YYYY-MM-DD");
            prevState.inputData.createdBy = NoteDetail.createdBy;
        }
    }

    UpdateNotes() {
        const { dispatch,t } = this.props;
        const { inputData } = this.state;
        inputData.createdBy = currentuser.name;
        dispatch(UpdateNotesData(inputData, this.props.history,t));
    }

    handleInputChange(e) {
        let nodeName = e.target.name;
        this.state.inputData[nodeName] = e.target.value;
        this.setState({});
    }

    handleDateChange(date) {
        this.state.inputData.date = Moment(
            new Date(Date.parse(date))
        ).format("YYYY-MM-DD");
        this.setState({
            SelectedDate: date,
            DatePickerIsOpen: false,
        });
    }

    openDatePicker() {
        this.setState({
            DatePickerIsOpen: !this.state.DatePickerIsOpen,
        });
    }

    handleBlur() {
        this.setState({
            DatePickerIsOpen: false,
        });
      }


    render() {
        const {t}=this.props;
        return (
            <div className="full-height">
                <div className="pt-3">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="panel-box">
                                <div className="row search-filter-box">
                                    <div className="col-lg-12">
                                        <div
                                            className="card mt-2 MM-card-header mb-0"
                                            style={{ backgroundColor: "white" }}
                                        >
                                            <div
                                                className="card-body"
                                                style={{
                                                    padding: "0rem",
                                                    backgroundColor: "#1a3464",
                                                    color: "white",
                                                }}
                                            >
                                                <h5
                                                    className="card-title ml-2 mt-2"
                                                    style={{ color: "092a51" }}
                                                >
                                                    {t("CommonText.EditShipReport")}
                                                </h5>
                                            </div>
                                        </div>
                                        <div className="row search-filter-box">
                                            <div className={"col-lg-4 "}>
                                                <label className="form-label">{t("DashboardShipReports.Title")}</label>
                                                <br></br>
                                                <input
                                                    className="form-control"
                                                    type="text"
                                                    name="title"
                                                    placeholder="Title"
                                                    onChange={(e) => this.handleInputChange(e)}
                                                    value={this.state.inputData.title}
                                                ></input>
                                            </div>
                                            <div className={"col-lg-4 "}>
                                                <label className="form-label">{t("DashboardShipReports.Date")}</label>
                                                <div
                                                    className="input-group add-on date datepicker"
                                                    data-date-format="yyyy-mm-dd"
                                                >
                                                    <input
                                                        className="form-control"
                                                        type="text"
                                                        name="date"
                                                        placeholder="Date"
                                                        onChange={(e) => this.handleInputChange(e)}
                                                        value={this.state.inputData.date}
                                                    ></input>
                                                    <DatePicker
                                                        selected={this.state.SelectedDate}
                                                        onChange={this.handleDateChange}
                                                        open={this.state.DatePickerIsOpen}
                                                        onClickOutside={this.handleBlur}
                                                        showMonthDropdown
                                                        showYearDropdown
                                                        dropdownMode="select"
                                                        className="form-control date-picker w-5 hide-date" />
                                                    <div
                                                        className="input-group-btn calendar-icon"
                                                        onClick={this.openDatePicker}
                                                    >
                                                        <button className="btn btn-default">
                                                            <i className="fa fa-calendar mt-1"></i>
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className={"col-lg-4 "}>
                                                <label className="form-label">{t("DashboardShipReports.Remarks")}</label>
                                                <br></br>
                                                <input
                                                    className="form-control"
                                                    type="text"
                                                    name="remarks"
                                                    placeholder="Remarks"
                                                    onChange={(e) => this.handleInputChange(e)}
                                                    value={this.state.inputData.remarks}
                                                ></input>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-lg-12 mt-2">
                                                <div
                                                    className="mb-2 search-btn-col"
                                                    style={{ textAlign: "end" }}
                                                >
                                                    <button
                                                        className="btn btn-primary text-uppercase txtside-btn txtht-btn blue"
                                                        type="submit"
                                                        onClick={() => this.UpdateNotes()}
                                                    >
                                                        {t("EquipmentServiceTypes.Update")}
                                                    </button>
                                                    <button
                                                        className="btn btn-light text-uppercase txtside-btn txtht-btn ml-3"
                                                        type="button"
                                                        onClick={() => this.moveClientList()}
                                                    >
                                                        {" "}
                                                        {t("ComplianceandBudgetScreen.Cancel")}{" "}
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    moveClientList = () => {
        const input = {
            noteID: 0,
            shipId: 0,
            title: "",
            remarks: "",
            date: "",
            createdBy: ""
        }
        this.setState({
            inputData: input
        })
        //  this.props.dispatch({ type: "ShowNoteSidePan", data: false });
        this.props.history.goBack();
    };
}
function mapStateToProps(state) {
    return {
        ShipInfo: state.ShipNotesReducer.ShipInfo,
        NoteDetail: state.ShipNotesReducer.NoteDetail
    };
}
function mapDispatchToProps(dispatch) {
    return {
        dispatch,
    };
}
export default withTranslation() (connect(
    mapStateToProps,
    mapDispatchToProps
)(EditNotes));
